import {AddressType, ClusterAddress, isPeerAddress, NodeAddress, Source} from '../state/types/common.js';
import {peerToAddress} from '../address.js';
import {MeshMessageType} from '../mesh.js';
import * as GatewayEncoders from '../common/encoders.js';

// compatibility with clojure
export type TransportAddress = ClusterAddress | NodeAddress | {type: 'peer', node: string, "peer-id": string};
export type TransportMessage = MeshMessageType & {
    source: TransportAddress;
    receiver?: TransportAddress;
}

function sourceToTransport(source: Source): TransportAddress {
    if (isPeerAddress(source)) {
        return {type: 'peer', node: source.node, "peer-id": source.peer};
    }
    return (source as TransportAddress);
}

function sourceFromTransport(source: TransportAddress): Source {
    if (source.type === 'peer') {
        return peerToAddress(source["node"], source["peer-id"]);
    }
    return (source as Source);
}


// returns receiver type and transport message
export function toTransportMessage(msg: MeshMessageType): [AddressType, TransportMessage] {
    const {receiver, body, source} = msg;
    const transportReceiver = sourceToTransport(receiver);
    const transportSource = sourceToTransport(source);
    return  [receiver.type, {...msg, source: transportSource, receiver: transportReceiver}];
}

export function fromTransportMessage(msg: TransportMessage): MeshMessageType {
    const {receiver: transportReceiver, body, source: transportSource} = msg;
    const receiver = sourceFromTransport(transportReceiver);
    const source = sourceFromTransport(transportSource);
    return {...msg, source, receiver}
}

export function codec<T> () {
    return GatewayEncoders.transit<T>(
        {
            namespaces: new Map<string, string>([
                ['commands', 'gateway.common.commands']
            ]),
            keywordize: new Map<string, GatewayEncoders.KeywordizeCommand>([
                //common
                ['/type', '*'],
                ['/to', new Set<string>(['all'])],
                // broker mesh
                ['/message/origin', '*'],
                ['/message/receiver/type', '*'],
                ['/message/source/type', '*'],
                ['/message/body/type', '*'],
                // ws mesh
                ['/data/origin', '*'],
                ['/data/receiver/type', '*'],
                ['/data/source/type', '*'],
                ['/data/body/type', '*'],
            ])
        }
    );
}
